package pl.michal_cyran.brand_hub.subpages.freelancing

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.HeroGridStyle
import pl.michal_cyran.brand_hub.components.widgets.VisibilityAware
import pl.michal_cyran.brand_hub.components.widgets.revealFadeSlideUp
import pl.michal_cyran.brand_hub.components.widgets.revealFadeSlideUpScale
import pl.michal_cyran.brand_hub.components.widgets.staggerDelay
import pl.michal_cyran.brand_hub.subpages.dayMathAd.composables.ExplanationCard
import pl.michal_cyran.brand_hub.subpages.freelancing.composables.PlatformCard
import pl.michal_cyran.brand_hub.toSitePalette

@Composable
fun FreelancingKMP() {
    val cm = ColorMode.current.toSitePalette()

    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(2.cssRem)
    ) {
        SimpleGrid(
            numColumns(1, md = 2),
            modifier = HeroGridStyle.toModifier().fillMaxWidth().gap(2.cssRem)
        ) {
            VisibilityAware(modifier = Modifier) { isVisible ->
                Column {
                    H1(
                        Modifier
                            .revealFadeSlideUp(isVisible, delayMs = 0)
                            .toAttrs()
                    ) {
                        SpanText(
                            "Potęga ",
                            modifier = Modifier.color(cm.textMuted)
                        )
                        SpanText(
                            "Kotlin Multiplatform.",
                            modifier = Modifier.color(cm.primary)
                        )
                    }

                    ExplanationCard(
                        icon = "bolt-lightning",
                        title = "Jeden kod, wiele platform",
                        body = "Dzięki nowoczesnej technologii jestem w stanie wydajnie tworzyć wieloplatformowe apliakcje",
                        modifier = Modifier
                            .revealFadeSlideUpScale(isVisible, delayMs = 150)
                    )

                    P(
                        Modifier
                            .revealFadeSlideUp(isVisible, delayMs = 300)
                            .toAttrs()
                    ) {
                        Text(
                            " Zamiast pisać tę samą logikę biznesową trzy razy, tworzymy ją raz w Kotlinie. Twoje reguły walidacji, komunikacja z API i bazy danych są współdzielone, podczas gdy UI pozostaje w 100% natywny dla każdego systemu. "
                        )
                    }
                }
            }

            VisibilityAware(modifier = Modifier) { isVisible ->
                Row(
                    horizontalArrangement = Arrangement.spacedBy(1.5.cssRem),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    val platforms = listOf(
                        Pair("mobile-screen", "Android"),
                        Pair("desktop", "Desktop"),
                        Pair("globe", "Web")
                    )

                    platforms.forEachIndexed { index, (iconName, title) ->
                        PlatformCard(
                            iconName = iconName,
                            title = title,
                            modifier = Modifier
                                .weight(1f)
                                .revealFadeSlideUpScale(
                                    isVisible,
                                    delayMs = staggerDelay(index, step = 130, offset = 150),
                                    distance = 18.px,
                                    fromScale = 0.9
                                )
                        )
                    }
                }
            }
        }
    }
}